import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserLoggedModel } from 'src/app/shared/models/UserLoginModel.model';
import { formatterRut } from 'chilean-formatter';
import { ExecutionContextService } from 'src/core/context/execution-context.service';

@Component({
    selector: 'app-perfil-usuario-detalle',
    templateUrl: './perfil-usuario-detalle.component.html',
    standalone: false
})
export class PerfilUsuarioDetalleComponent implements OnInit {
  constructor(private readonly executionContext: ExecutionContextService) {}
  @Output() eventoPadreCambiarEtapa = new EventEmitter<number>();
  @Input() numberEtapas: any;
  @Input() dataUsusario: UserLoggedModel;

  isMixer: boolean = false;

  ngOnInit(): void {
    this.isMixer = this.executionContext.getAuthenticated()?.role === 'mixer';
  }

  formatRut(rut: string | number): string {
    if (rut === null || rut === undefined || rut === '') return '';
    return formatterRut(rut);
  }

  onChangeEdicion() {
    this.eventoPadreCambiarEtapa.emit(this.numberEtapas.Modifi);
  }
}


